import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';

import '../scss/function-sounce-picture.scss';
import { styled } from '@mui/system';
import { LinearProgress } from '@mui/material';
import Color from '@/tool/color';
import { isEmpty, round } from 'lodash';
import moBility from '../../../store/mobility';


interface IProps { }
interface IState { }

const RightChart = (props: IProps, state: IState) => {
  const [active, setActive] = useState<number>(0);
  const { roleList, roleRightActive } = moBility;
  const sum = (arr: any) => {
    if (arr.length > 0) {
      return arr.reduce((prev: any, curr: any, idx: any, arr: any) => {
        return prev + curr;
      });
    }
    return 0;
  };

  const showList = useMemo(() => {
    if (!isEmpty(roleList)) {
      if (roleRightActive === 'role') {
        return roleList.outflow?.category_details;
      }
      return roleList.outflow?.industry_details;
    }
    return [];
  }, [roleRightActive, roleList])

  const leftHeight = (val: number) => {
    if (!isEmpty(showList)) {
      const list: any = [];
      showList?.forEach((item: { ratio: number; }) => {
        list.push(item.ratio);
      });
      return `${(val / sum(list)) * (list.length * 50 + 40)}px`;
    }
    return '0px'
  };

  const getPictureHeight = useMemo(() => {
    if (!isEmpty(showList)) {
      const list: any = [];
      showList?.forEach((item: { ratio: number; }) => {
        list.push(item.ratio);
      });

      let val: number = 0;
      for (let i = 0; i < active + 1; i += 1) {
        if (i === active) {
          val += (list[i] / 2);
        } else {
          val += list[i];
        }
      }
      return `${(val / sum(list)) * (list.length * 50) - active * 50 + 4}px`;
    }
    return '0px';
  }, [showList]);

  useEffect(() => {
    return () => { };
  }, []);

  const DProgress = styled(LinearProgress)({
    borderRadius: '4px',
    height: '8px',
    backgroundColor: Color.blackColor(0.04),
  });

  return (
    <section className="function-sounce-picture">
      <section className="function-sounce-picture-left">
        {
          showList?.map((item: any, i: number) => (
            <p
              key={`${i.toString()}`}
              style={{
                width: '100px',
                height: leftHeight(item.ratio),
                backgroundImage: active === i ?
                  'url(https://file.smartsalary.cn/web-img%402.0/market/image/outalentactive.png)' :
                  'url(https://file.smartsalary.cn/web-img%402.0/market/image/outalent.png)',
                backgroundSize: '100% 100%',
              }}
              onMouseEnter={() => { setActive(i); }}
              onMouseLeave={() => { setActive(0); }}
              className="left-items" />
          ))
        }
        <img src="https://file.smartsalary.cn/web-img%402.0/market/image/yellow.png" alt=""
          className="inflow-sounce-picture-left-picture"
          style={{ height: `${getPictureHeight}`, top: `${active * 50 + 36}px` }} />
      </section>
      <section className="function-sounce-picture-mid">
        {
          showList?.map((item: any, i: number) => (
            <section
              className={active === i ? 'mid-items1' : 'mid-items'}
              key={`${i.toString()}`}>
              <p
                key={`${i.toString()}q`}>
                <b
                  style={{
                    background: active === i ? Color.secondary : 'none',
                    borderColor: active === i ? Color.secondary : Color.ccc,
                  }} />
                <span className="mid-item-name">{item.category_name || item.industry_name}</span>
                <span>{`${round(item.ratio * 100, 1)}%`}</span>
              </p>
              <section style={{ paddingLeft: 30 }}>
                <DProgress variant="determinate"
                  value={round(item.ratio * 100, 1)} className="out" />
              </section>
            </section>
          ))
        }
        <p className="mid-item-left-connect"
          style={{
            top: `${active * 50 + 56}px`,
            background: Color.secondaryColor(0.3),
          }} />
      </section>
    </section>
  );
};

export default observer(RightChart);
